<div *ngIf="spin" class="d-flex justify-content-center">
  <app-spinner></app-spinner>
</div>
<div *ngIf="!spin" style="min-height: 550px">
  <nb-card *ngIf="mode === 'view' || isDraft">
    <nb-card-header>
      <div *ngIf="!deploying && drb">
        <h3 *ngIf="mode === 'create'" style="position: relative" i18n>Create/Edit DRB</h3>
        <h3 *ngIf="mode === 'view'" style="position: relative" i18n>View DRB</h3>
        <p style="position: relative">{{ bundle_name }}</p>
        <br />
        <div class="row" *ngIf="mode === 'view'">
          <div class="col-2">
            <div i18n>DRB version:</div>
          </div>
          <div class="col-3">
            <ng-select
              id="version"
              name="version"
              placeholder="Select DRB Version"
              i18n-placeholder
              (change)="onChange($event)"
              [(ngModel)]="version"
              [clearable]="false"
              required
            >
              <ng-option *ngFor="let v of versions" [value]="v"> {{ v }} </ng-option>
            </ng-select>
          </div>
        </div>
        <hr />
        <div class="row" *ngIf="mode === 'create' || version">
          <div class="row">
            <div class="col-4">
              <div i18n>Version:</div>
              <p>{{ drb.version }}</p>
            </div>
            <div class="col-4">
              <div i18n>Created by:</div>
              <p>{{ drb.created_by }}</p>
            </div>
            <div class="col-4">
              <div i18n>Created on:</div>
              <p>{{ utility.convertUnixTime_global(drb.created_ts) }}</p>
            </div>
            <div class="col-4">
              <div i18n>Status:</div>
              <p>{{ drb.status }}</p>
            </div>
            <div class="col-4" *ngIf="mode === 'view'">
              <div i18n>Draft:</div>
              <p style="text-transform: uppercase">{{ drb.draft }}</p>
            </div>
            <div class="col-4">
              <div i18n>Last updated by:</div>
              <p>{{ drb.last_updated_by }}</p>
            </div>
            <div class="col-4">
              <div i18n>Last updated on:</div>
              <p>{{ utility.convertUnixTime_global(drb.last_updated_ts) }}</p>
            </div>
            <div class="col-4">
              <div i18n>Owner:</div>
              <p>{{ drb.owner }}</p>
            </div>
            <div class="col-4">
              <div style="margin-right: 0.5rem" i18n>Contributors:</div>
              <button
                *ngIf="mode === 'create' && drb.owner === username"
                nbButton
                size="small"
                shape="round"
                (click)="manageContributors()"
              >
                <nb-icon icon="edit-outline"></nb-icon>
              </button>
              <p>{{ displayContributors() }}</p>
            </div>
            <div class="col-4" *ngIf="environment === 'stage' && mode === 'view'">
              <div i18n>Deployed to stage:</div>
              <p style="text-transform: uppercase">{{ drb.deployed_to_stage }}</p>
            </div>
            <div class="col-4" *ngIf="environment === 'stage' && mode === 'view' && drb.deployed_to_stage">
              <div i18n>Deployed to stage on:</div>
              <p>{{ utility.convertUnixTime_global(drb.deployed_to_stage_ts) }}</p>
            </div>
            <div class="col-4" *ngIf="environment === 'prod' && mode === 'view'">
              <div i18n>Deployed to prod:</div>
              <p style="text-transform: uppercase">{{ drb.deployed_to_prod }}</p>
            </div>
            <div class="col-4" *ngIf="environment === 'prod' && mode === 'view' && drb.deployed_to_prod">
              <div i18n>Deployed to prod on:</div>
              <p>{{ utility.convertUnixTime_global(drb.deployed_to_prod_ts) }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="deploying">
        <div class="row">
          <div i18n>DRB draft version is currently deploying.</div>
        </div>
        <div class="row">
          <div i18n>If you want to check DRB information please go to View page.</div>
        </div>
        <div class="row">
          <div i18n>If you want to create new draft version, please wait until deployment finishes.</div>
        </div>
        <div class="row">
          <div class="col-1">
            <button nbButton size="small" shape="round" (click)="reload()" i18n>Reload</button>
          </div>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div *ngIf="drb && !deploying">
        <mat-tab-group>
          <mat-tab label="Strings" i18n-label>
            <div *ngIf="(drb && !translating) || mode === 'view'">
              <div *ngIf="mode === 'create' && !drb.translations_received" class="m-3">
                <nb-toggle
                  labelPosition="start"
                  status="success"
                  [checked]="drb.translate"
                  (click)="optForTranslation()"
                  nbTooltipPlacement="right"
                  nbTooltip="Opting strings for translation will affect the total translation cost!"
                  i18n-nbTooltip
                  class="ml-2"
                >
                  <strong class="text-uppercase" i18n>Translate</strong>
                </nb-toggle>
                <div *ngIf="drb.translate" class="translateScheduleMsg ml-2">
                  Next translation process is scheduled for {{ getNextMonday() }} at 4:00 PM ET.
                </div>
              </div>
              <nb-accordion class="m-3">
                <nb-accordion-item>
                  <nb-accordion-item-header i18n> Translations Metadata </nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <div class="row">
                      <div class="col-4">
                        <div i18n>Translate:</div>
                        <p>{{ drb.translate }}</p>
                      </div>
                      <div class="col-4">
                        <div i18n>Status:</div>
                        <p>{{ drb.translation_status }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4" *ngIf="drb.translations_submitted_ts">
                        <div i18n>Translations submitted on:</div>
                        <p>{{ utility.convertUnixTime_global(drb.translations_submitted_ts) }}</p>
                      </div>
                      <div class="col-4" *ngIf="drb.translations_received_ts">
                        <div i18n>Translations received on:</div>
                        <p>{{ utility.convertUnixTime_global(drb.translations_received_ts) }}</p>
                      </div>
                      <div class="col-4" *ngIf="drb.translations_submitted_ts && !drb.translations_received_ts">
                        <div i18n>Translations expected by:</div>
                        <p>
                          {{ getTwoWeeksFromNow(drb.translations_submitted_ts) }}
                          <span style="color: red" i18n> (can be subject to change) </span>
                        </p>
                      </div>
                    </div>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
              <app-ngx-mat-table
                tableName="Strings"
                dataType="string"
                sortActive="id"
                [tableData]="strings"
                [showActions]="showActions"
                (clickedButton)="clickedButton('string', $event)"
                i18n-tableName
              ></app-ngx-mat-table>
              <router-outlet></router-outlet>
            </div>
            <div *ngIf="mode === 'create' && translating">
              <nb-card accent="info">
                <nb-card-header i18n>Strings are currently in translation process</nb-card-header>
                <nb-card-body>
                  <div class="row">
                    <div i18n>Submitted on {{ utility.convertUnixTime_global(drb.translations_submitted_ts) }}</div>
                  </div>
                  <p i18n>If you want to inspect the strings, you can do so in the DRBs view window.</p>
                </nb-card-body>
              </nb-card>
            </div>
          </mat-tab>
          <mat-tab label="Files" i18n-label>
            <br />
            <app-ngx-mat-table
              tableName="Files"
              dataType="file"
              sortActive="id"
              [tableData]="files"
              [showActions]="showActions"
              (clickedButton)="clickedButton('file', $event)"
              i18n-tableName
            ></app-ngx-mat-table
          ></mat-tab>
          <mat-tab label="Images" i18n-label>
            <br />
            <app-ngx-mat-table
              tableName="Images"
              dataType="image"
              sortActive="id"
              [tableData]="images"
              [showActions]="showActions"
              (clickedButton)="clickedButton('image', $event)"
              i18n-tableName
            ></app-ngx-mat-table
          ></mat-tab>
          <mat-tab label="Links" i18n-label>
            <br />
            <app-ngx-mat-table
              tableName="Links"
              dataType="link"
              sortActive="id"
              [tableData]="links"
              [showActions]="showActions"
              (clickedButton)="clickedButton('link', $event)"
              i18n-tableName
            ></app-ngx-mat-table
          ></mat-tab>
          <mat-tab label="Videos" i18n-label>
            <br />
            <app-ngx-mat-table
              tableName="Videos"
              dataType="video"
              sortActive="id"
              [tableData]="videos"
              [showActions]="showActions"
              (clickedButton)="clickedButton('video', $event)"
              i18n-tableName
            ></app-ngx-mat-table
          ></mat-tab>
        </mat-tab-group>
      </div>
    </nb-card-body>
  </nb-card>
</div>
